import React, { Component } from 'react';
import { conditionButton, renderButton, getImageRand } from '../../../helper/helperFunctions';
import { Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import { LazyLoadImage } from 'react-lazy-load-image-component';

class ImagesAi extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    renderButton = ( condition, label, similarity_range = null) => {
        return condition && <button className="backlit-btn" style={{cursor: 'pointer'}} onClick={() => { this.props.openSimilarImageModal(this.props.image) }}>{label === 'Similar' ? label + similarity_range : label}</button>;
    }

    isValidDate = (date) => {
        let tempDate = new Date (date);
        return tempDate instanceof Date && !isNaN(tempDate.getTime());
    }


    render() {
        const { image, section, onLoad, gridView, movedImage, isSelected, imageCacheBust } = this.props;
        const imageRand = getImageRand(image, imageCacheBust);
        return (
            <div
                style={{marginLeft: 1, marginRight: 1}}
                id={`image-row-${section === 'Producer' ? `${section}-${image.producer_sort_order}` : `${section}-${image.user_sort_order}`}`}
                className= {`image-rows${image.highlighted ? ' highlighted' : ''} ${section === 'Edited' && image.is_duplicate_group  ? ' duplicate_underline' : ''} ${section === 'Edited' && image.is_inappropriate  ? ' is_inappropriate_underline' : ''} ${section === 'Edited' && image.is_low_quality  ? ' is_low_quality_underline' : ''} ${(image.exif_date_taken == null || !this.isValidDate(image.exif_date_taken)) ? ' nonexif_underline' : ''} ${section === 'Producer' && isSelected ? ' highlight-select-ai' : ''} ${image.is_captured_by_camera ? 'isCameraImage_underline' : ''}`}
                >
                
                {/* rotateImageAi */}
                <div className='ai_img_btn'>
                    {
                        section === 'Producer' &&
                        <div className='flexElem mb-sm' style={{justifyContent: 'center'}}>
                            <div style={{margin: '0 10px', cursor: 'pointer'}} onClick={() => {
                                this.props.rotateImageAi(image, 'left')
                                }}>
                                <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Rotate Left</Tooltip>}>
                                    <i style={{fontSize: '14px', width: '100%'}} className="fa fa-undo"
                                    aria-hidden="true"></i>
                                </OverlayTrigger>
                            </div>
                            
                            <div style={{margin: '0 10px', cursor: 'pointer'}} onClick={() => {
                                this.props.rotateImageAi(image, 'right')
                                }}>
                                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip">Rotate Right</Tooltip>}>
                                    <i style={{fontSize: '14px', width: '100%'}} className="fa fa-repeat"
                                    aria-hidden="true"></i>
                                </OverlayTrigger>
                            </div>

                            {
                                typeof this.props.openCropEditorFromGrid === 'function' &&
                                <div style={{margin: '0 10px', cursor: 'pointer'}} onClick={() => {
                                    this.props.openCropEditorFromGrid(image);
                                }}>
                                    <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip">Crop Image</Tooltip>}>
                                        <i style={{fontSize: '14px', width: '100%'}} className="fa fa-crop" aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </div>
                            }

                            <div style={{margin: '0 10px', cursor: 'pointer'}} onClick={() => {
                                this.props.handleSetAiImageFlag(image, 'use_in_full_video')
                                }}>
                                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip">Do not include in video</Tooltip>}>
                                    <i style={{fontSize: '15px', width: '100%'}} className="fa fa-ban"
                                    aria-hidden="true"></i>
                                </OverlayTrigger>
                            </div>

                            <div style={{margin: '0 10px', cursor: 'pointer'}} disabled={movedImage ? false : true} onClick={() => {this.props.moveImageHandler(image)}}>
                                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip">Click to drop the selected image</Tooltip>}>
                                    <i style={{fontSize: '15px', width: '100%'}} className="fa fa-arrow-down"
                                    aria-hidden="true"></i>
                                </OverlayTrigger>
                            </div>

                            <div style={{margin: '0 10px', cursor: 'pointer'}} onClick={() => {
                                this.props.setMoveImageId(image.id)
                                }}>
                                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip">Click to move this image</Tooltip>}>
                                    <i style={{fontSize: '15px', width: '100%'}} className="fa fa-arrow-up"
                                    aria-hidden="true"></i>
                                </OverlayTrigger>
                            </div>
                            
                        </div>
                    }
                    {/* rotateImageAi */}

                    {/* Include in video icon in Edited row*/}
                    {
                        section === 'Edited' && image.use_in_full_video !== 1 &&
                            <div className='mb-sm' style={{margin: '0 10px', cursor: 'pointer'}} onClick={() => {
                                this.props.handleIncludeInFullVideo(image, 'use_in_full_video')
                                }}>
                                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip">Include in video</Tooltip>}>
                                    <i style={{fontSize: '15px', width: '100%'}} className="fa fa-check"
                                    aria-hidden="true"></i>
                                </OverlayTrigger>
                            </div>
                    }
                    <LazyLoadImage
                        key={`${image.id}-${imageRand}`}
                        section={section}
                        src={image.resized_image_path.replace('SIZE', 'thumb_large') + "?rand=" + imageRand}
                        alt='image'
                        onClick={(e) => {this.props.selectImageHandler(e, image)}}
                        className='image-style'
                        placeholder={<div><img src={"/images/loading200.gif"} alt="Loading..." /></div>}
                        visibleByDefault={image.src === '/images/' + image.placeholder}
                        effect="blur"
                        threshold='1'
                    />
                    
                </div>
                <div className='image-btn' >
                    <span className='position-ai'>Position {section === 'Producer' ? +image.producer_sort_order : +image.user_sort_order }</span>
                    {
                        section === 'Producer' && image.producer_sort_order !== image.user_sort_order &&
                            <button className='from-btn'>
                                {'From ' + image.user_sort_order}
                            </button>
                    }
                    {
                        section === 'Edited' && image.producer_sort_order !== image.user_sort_order && image.use_in_full_video === 1 &&
                            <button className='from-btn'>
                                {'To ' + image.producer_sort_order}
                            </button>
                    }
                </div>
                <div>
                    {
                        
                        conditionButton(image)
                    }
                    {
                        // && image.no_of_persons_detected < 5
                        (image.is_duplicate_group === 1 && image.use_in_full_video !== 1) ?
                            image.similarity_percentage * 100 >= 100
                            ? 
                                this.renderButton((true && (image.use_in_full_video !== 1 && (image.similarity_percentage && image.similarity_percentage * 100 == 100))), 'duplicate')
                            :
                                this.renderButton((image.is_duplicate_group === 1 && image.use_in_full_video !== 1), 'Similar', image.similarity_range)
                                // image.no_of_persons_detected < 5 
                                // ?
                                //     this.renderButton((image.is_duplicate_group === 1 && image.use_in_full_video !== 1), 'Similar')
                                // :
                                //     this.renderButton((image.is_duplicate_group === 1 && image.use_in_full_video !== 1), 'Similar Group')
                        :
                        ""
                    }
                </div>
                {
                    this.props.showImgData &&
                    <React.Fragment>
                        <div className="galleryInfo p-sm">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip id={image.id}>
                                    Date
                                </Tooltip>
                            }>
                                <span className='text-muted dark text_14'>{image.date_taken}</span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip id={image.id}>
                                    Photo Name
                                </Tooltip>
                            }>
                                <span className='galleryId text_14'>{image.id}</span>
                            </OverlayTrigger>
                        </div>
                    </React.Fragment>
                }
            </div>
        );
    }
}


export default ImagesAi;